import { ReactNode } from 'react'

import { IApiError } from '@/common/interfaces'

import { parseCanceledCardsMessage } from './parseCanceledCardsMessage'

const DEFAULT_API_ERROR_MESSAGE =
  'Ops. Algo deu errado, tente novamente mais tarde!'

export function renderCanceledCardsErrorMessage(
  message: string,
  key?: string,
): ReactNode {
  const safeMessage = message?.trim() ? message : DEFAULT_API_ERROR_MESSAGE
  const parsed = parseCanceledCardsMessage(safeMessage)

  if (parsed) {
    return (
      <span key={key} className="flex w-full flex-col gap-4 items-start">
        <p className="prose-body">{parsed.intro}</p>
        <ul className="list-disc pl-5 flex w-full flex-col gap-2 items-start">
          {parsed.proxies.map((proxy) => (
            <li key={proxy} className="prose-body">
              {proxy}
            </li>
          ))}
        </ul>
      </span>
    )
  }

  return (
    <p key={key} className="prose-body">
      {safeMessage}
    </p>
  )
}

export function renderCustomApiMessage(
  customMessage?: Array<IApiError> | string,
  keyPrefix = 'custom-message',
): ReactNode {
  if (!customMessage?.length) {
    return null
  }

  if (Array.isArray(customMessage)) {
    return customMessage.map((item, index) =>
      renderCanceledCardsErrorMessage(
        item.message,
        `${keyPrefix}-${item.key ?? index}`,
      ),
    )
  }

  return renderCanceledCardsErrorMessage(customMessage)
}
